import { render } from "./DepartmentsMap.vue?vue&type=template&id=66be9997"
import script from "./DepartmentsMap.vue?vue&type=script&lang=js"
export * from "./DepartmentsMap.vue?vue&type=script&lang=js"

import "./DepartmentsMap.vue?vue&type=style&index=0&id=66be9997&lang=scss"

import exportComponent from "/__w/oscar/oscar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__